window.LastSeenPage = {
  list: []
};

LastSeenPage.init = function () {
  $(".last-seen .product").each(function (i, element) {
    LastSeenPage.list.push(new ProductView(element, LastSeenPage));
  });
  LastSeenPage.markFavs();
};

LastSeenPage.addProductToFav = function (product) {
  Fav.favProduct(product._id, function () {
    Fav.loadFavs();
    var productView = LastSeenPage.findProductView(product._id);
    productView.setFav(true);
  });
};

LastSeenPage.findProductView = function (productId) {
  for (var i = 0; i < LastSeenPage.list.length; i++) {
    if (LastSeenPage.list[i].product._id === productId) {
      return LastSeenPage.list[i];
    }
  }
};

LastSeenPage.removeProductFromFavs = function (product) {
  Fav.unFavProduct(product._id, function () {
    Fav.loadFavs();
    var productView = LastSeenPage.findProductView(product._id);
    productView.setFav(false);
  });
};

LastSeenPage.removeProductView = function (productId) {
  $('[data-id="' + productId + '"]').remove();
  for (var i = 0; i < LastSeenPage.list.length; i++) {
    if (LastSeenPage.list[i].product._id === productId) {
      LastSeenPage.list.splice(i, 1);
      break;
    }
  }
};

LastSeenPage.addProductToCart = function (product) {
  if (product.versionQty > 1) {
    VersionModal.loadModal(product._id, {
      onAddToCart: function (product) {
        Cart.addItems({
          type: product.type,
          product: product.product,
          version: product.version,
          qty: 1
        });
      }
    });
  } else {
    Cart.addItems({
      type: product.type,
      product: product._id,
      version: product.version,
      qty: 1
    });
  }
};

LastSeenPage.markFavs = function () {
  Fav.loadFavs(function (resp) {
    LastSeenPage.list.forEach(function (productView) {
      if (resp.favorites && resp.favorites.indexOf(productView.product._id) >= 0) {
        productView.setFav(true);
      }
    })
  });
}

$(LastSeenPage.init);
